const query = (id, isPreview) => `
{
  textContent (id: "${id}", preview: ${isPreview}) {
    title
    longTitle
    shortDescription
    content
    variant
    cameoImages {
    internalTitle
    altText
    cameoMediumMobile {
      title
      description
      url
    }
    cameoMedium {
      title
      description
      url
    }
    cameoLargeMobile {
      title
      description
      url
    }
    cameoLarge {
      title
      description
      url
    }
  }
    badgeHeading
    badgeContent
    jsonEditor
    elementId
    socailIconEnable
    socialLinks {
      internalTitle
      linkCollection{
        items{
          title
          url
          ariaLabel
          images{
            altText
            imageMobile {
              title
              description
              contentType
              fileName
              size
              url
              width
              height
            }
            imageDesktop {
              title
              description
              contentType
              fileName
              size
              url
              width
              height
            }

          }
        }
      }
    }

  }
}
`

module.exports = { query }